<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.0366 5.08652C12.287 4.98707 12.5729 5.04635 12.7635 5.23682C12.9539 5.42735 13.0132 5.71333 12.9138 5.96367L11.0426 10.6632C10.974 10.8351 10.8374 10.9716 10.6655 11.0402L5.966 12.9114C5.71558 13.0111 5.42977 12.9517 5.23915 12.7611C5.04858 12.5705 4.98916 12.2847 5.08885 12.0343L6.96005 7.33564L6.98905 7.27236C7.06352 7.13005 7.18734 7.01769 7.33798 6.95771L12.0366 5.08652ZM8.10614 8.10381L6.92313 11.0763L9.89559 9.89326L11.0786 6.9208L8.10614 8.10381Z"
            fill="#8E8E93"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.99999 1.0752C13.3767 1.07525 16.925 4.62348 16.9251 9.00029C16.925 13.3771 13.3767 16.9253 8.99999 16.9254C4.62328 16.9253 1.07494 13.3771 1.07489 9.00029C1.07495 4.62348 4.62328 1.07525 8.99999 1.0752ZM9.67499 3.75059C9.67478 4.1232 9.37265 4.42559 8.99999 4.42559C8.62733 4.42559 8.3252 4.1232 8.32499 3.75059V2.45947C5.23285 2.77486 2.77456 5.2331 2.45917 8.32529H3.75028C4.12289 8.3255 4.42528 8.62763 4.42528 9.00029C4.42528 9.37295 4.12289 9.67508 3.75028 9.67529H2.45917C2.77451 12.7675 5.23282 15.2257 8.32499 15.5411V14.25C8.32515 13.8773 8.6273 13.575 8.99999 13.575C9.37268 13.575 9.67482 13.8773 9.67499 14.25V15.5402C12.7672 15.2248 15.2254 12.7675 15.5408 9.67529H14.2497C13.877 9.67513 13.5747 9.37299 13.5747 9.00029C13.5747 8.6276 13.877 8.32545 14.2497 8.32529H15.5408C15.2254 5.23307 12.7672 2.77482 9.67499 2.45947V3.75059Z"
            fill="#8E8E93"
        />
    </svg>
</template>
